const dateFormatReducer = (dateFormat = 'YYYY-MM-DD', action) => {
    switch (action.type) {
        case "ADD_DATE_FORMAT":
            return action.payload;
        default:
            return dateFormat;
    }
};

export default dateFormatReducer;